import { render, staticRenderFns } from "./upgradeContract_sebredesign.vue?vue&type=template&id=c71d27dc&scoped=true"
import script from "./upgradeContract_sebredesign.vue?vue&type=script&lang=js"
export * from "./upgradeContract_sebredesign.vue?vue&type=script&lang=js"
import style0 from "./upgradeContract_sebredesign.vue?vue&type=style&index=0&id=c71d27dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71d27dc",
  null
  
)

export default component.exports